module.exports = __webpack_public_path__ + "media/honey-icons/icon-thermostat-gen-4-87a1c495.svg";